import graph from './graph';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { Button, Tooltip } from '@mui/material';
import { isEmptyObject } from 'helpers/formatObject';

export default function ShippingRequest({ ids, shop, refetch }) {
  const { userToken } = useSelector((state) => state.auth);

  const [request, { loading }] = useMutation(graph.request.query, {
    context: {
      serviceName: graph.request.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onRequest = async () => {
    try {
      const { data, errors } = await request({
        variables: {
          order_id: ids,
          shop_id: shop,
          status: 'TODO',
          type: 'SHIPPING',
        },
      });
      if (!errors) {
        refetch();
        if (!isEmptyObject(data)) {
          data[graph.request.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  return (
    <Tooltip title="درخواست حمل">
      <Button
        size="small"
        color="info"
        disableElevation
        variant="contained"
        sx={{ width: 140 }}
        disabled={loading}
        onClick={onRequest}
      >
        درخواست حمل
      </Button>
    </Tooltip>
  );
}
